import { streamsStore } from "@/libs/stores/streams.store";

export const useCreatorStreamingStatus = (creatorId) => {
  if (!creatorId) return false;
  
  // Since the component using this hook is already observer, 
  // this will automatically update when streamsStore.streams changes
  return streamsStore.streams.some(stream => stream.creatorId === creatorId);
};